module.exports = __webpack_public_path__ + "static/img/voice2_right.3edb8b1b.png";